<template>
	<div class="page">
		<!-- your page -->
		<div class="about">
			<div class="title">
				{{title}}
			</div>
			<div class="content" v-html="content"></div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'about',
		data(){
			return {
				title:"关于我们",
				content:""
			}
		},
		methods:{
			fetchData(){
				var data = {
					article_id:12,
					method: "articles.getArticleDetail"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.content = res.data.content
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.about{
		padding: 0px 10px;
		box-sizing: border-box;
	}
	.title{
		width: 100%;
		height: 50px;
		border-bottom: 1px solid #C3C3C3;
		line-height: 60px;
	}
</style>
